import axiosInstance from "../utils/axiosConfig";
import { EmailLogPaginatedListDto, SentEmailLogDto } from "../interfaces/IEmailLogs";

export async function getAllEmailLogs(
  limit: number,
  pageNumber: number = 1,
  initialCursorId: string | null = null,
  timeFilter?: string
): Promise<EmailLogPaginatedListDto> {
  try {
    const url = `emails/logs?Limit=${limit}`
      + `&PageNumber=${pageNumber}`
      + (timeFilter ? `&Filter=${timeFilter}` : "")
      + (initialCursorId ? `&InitialCursorId=${initialCursorId}` : "");

    const response = await axiosInstance.get(url);

    if (!response?.data) {
      return { totalPages: 1, emailLogs: [] };
    }

    const emailLogs: SentEmailLogDto[] = response.data.emailLogs.map((log: any) => ({
      id: log.id,
      timestamp: new Date(log.timestamp).toISOString(),
      emailAddresses: log.emailAddresses || [],
      subject: log.subject,
      message: log.message,
      taskNames: log.taskNames || [],
      fileNames: log.fileNames || [],
    }));

    return { totalPages: response.data.totalPages, emailLogs };
  } catch (error: any) {
    console.error("Error fetching email logs:", error.response?.data || error.message);
    return { totalPages: 1, emailLogs: [] };
  }
}

export async function setAlertLogDeleteFrequency(id: string, frequency: number): Promise<any> {
    try {
      const url = `logs/config/${id}`;
      const response = await axiosInstance.put(url, { value: frequency }); 
  
      return response; 
    } catch (error) {
      console.error("Error setting alert log delete frequency:", error);
      throw error;
    }
  }
  
  export async function getAlertLogDeleteFrequency(id: string): Promise<any> {
    try {
      const url = `logs/config/${id}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching alert log delete frequency:", error);
      throw error;
    }
  }